import ComponentWithSocket from '../../../lib/component'
import { Component } from 'vue-property-decorator';

import * as Store from '../../../store';

import template from './list.vue';
import moment from 'moment';

import WebsocketClient, { WebsocketsListener } from '../../../utils/ws';

@Component({
    mixins: [template]
})

export default class UsersList extends ComponentWithSocket {

    private data: { users: any[], server: any } = {
        users: [],
        server: undefined
    };

    rejectReason: string = ''
    selectedVerification?: any

    constructor() {

        super();

        this.wsListener.onGet('admin.statistics.live', (success: boolean, data: any) => {

            Store.commitLoaderVisibility(this.$store, false);

            if (success) {
                this.data.users = data.users;
                this.data.server = data.server;
            }

            setTimeout(() => {
                this.wsListener.sendGet('admin.statistics.live');
            }, 1000)

        });

    }

    beforeRouteLeave(to: any, from: any, next: any) {
        this._beforeLeave(to, from)
        next()
    }

    mounted() {

        Store.commitLoaderVisibility(this.$store, true);

        this.wsListener.sendGet('admin.statistics.live');

    }

}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--2!./src/views/statistics/live/index.ts